import api from 'api';
import confirm from 'modules/confirm';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

export default function useDeleteLead() {
  const { popServerError } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  return useCallback(
    async (
      leadId: string,
      setIsLoading: (isLoading: boolean) => void,
      onSuccess?: () => void,
    ) => {
      if (
        await confirm(
          {
            title: t('areYouSureDeleteLead'),
            content: t('deleteWarning'),
            type: 'delete',
            submitBtnText: t('deleteLeadConfirm'),
            cancelBtnText: t('deleteLeadReject'),
          },
          true,
        )
      ) {
        try {
          setIsLoading(true);
          await api.dealRoom.deleteLead(leadId);
          onSuccess?.();
        } catch (e) {
          popServerError(e);
        } finally {
          setIsLoading(false);
        }
      }
    },
    [popServerError, t],
  );
}
